// FreshLock — JS propio, vanilla, sin dependencias externas.

function flInitReveal() {
  var els = document.querySelectorAll('.fl-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('fl-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('fl-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function flInitContadores() {
  var els = document.querySelectorAll('[data-fl-contador]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      obs.unobserve(el);
      var fin = parseFloat(el.getAttribute('data-fl-contador')) || 0;
      var sufijo = el.getAttribute('data-fl-sufijo') || '';
      var dur = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var prog = Math.min((ts - inicio) / dur, 1);
        var valor = Math.round(fin * (1 - Math.pow(1 - prog, 3)));
        el.textContent = valor + sufijo;
        if (prog < 1) requestAnimationFrame(paso);
      }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        el.textContent = fin + sufijo;
      } else {
        requestAnimationFrame(paso);
      }
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { obs.observe(el); });
}

function flInitAcordeon() {
  var grupos = document.querySelectorAll('[data-fl-faq]');
  grupos.forEach(function (grupo) {
    var pregunta = grupo.querySelector('[data-fl-faq-pregunta]');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierto = grupo.classList.contains('fl-faq-abierto');
      grupo.parentElement.querySelectorAll('[data-fl-faq]').forEach(function (g) {
        g.classList.remove('fl-faq-abierto');
      });
      if (!abierto) grupo.classList.add('fl-faq-abierto');
    });
  });
}

function flInitVariantes() {
  var forms = document.querySelectorAll('[data-fl-form-producto]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-fl-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var contenedor = form.closest('.fl-producto-compra') || form;
    var inputId = form.querySelector('input[name="id"]');
    var grupos = form.querySelectorAll('[data-fl-opcion-grupo]');
    var precioEl = contenedor.querySelector('[data-fl-precio]');
    var comparadoEl = contenedor.querySelector('[data-fl-precio-comparado]');
    var ahorroEl = contenedor.querySelector('[data-fl-ahorro]');
    var botón = form.querySelector('[data-fl-agregar]');

    function moneda(centavos) {
      var partes = (Number(centavos) / 100).toFixed(2).split('.');
      var entero = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return '$' + entero + ',' + partes[1];
    }

    function actualizar() {
      if (!grupos.length) return;
      var valores = Array.prototype.map.call(grupos, function (g) {
        var marcado = g.querySelector('input:checked');
        return marcado ? marcado.value : null;
      });
      var encontrada = variantes.find(function (v) {
        return v.options.every(function (op, i) { return op === valores[i]; });
      });
      if (!encontrada) return;
      inputId.value = encontrada.id;
      if (precioEl) precioEl.textContent = moneda(encontrada.price);
      var hayAhorro = encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price;
      if (comparadoEl) {
        if (hayAhorro) {
          comparadoEl.textContent = moneda(encontrada.compare_at_price);
          comparadoEl.style.display = '';
        } else {
          comparadoEl.style.display = 'none';
        }
      }
      if (ahorroEl) {
        if (hayAhorro) {
          var prefijo = ahorroEl.getAttribute('data-fl-ahorro-prefijo') || '';
          ahorroEl.textContent = (prefijo + ' ' + moneda(encontrada.compare_at_price - encontrada.price)).trim();
          ahorroEl.style.display = '';
        } else {
          ahorroEl.style.display = 'none';
        }
      }
      grupos.forEach(function (g) {
        g.querySelectorAll('.fl-nivel').forEach(function (lab) { lab.classList.remove('fl-nivel-activo'); });
        var marcado = g.querySelector('input:checked');
        if (marcado) {
          var label = marcado.closest('.fl-nivel');
          if (label) label.classList.add('fl-nivel-activo');
        }
      });
      if (botón) {
        botón.disabled = !encontrada.available;
        botón.textContent = encontrada.available
          ? botón.getAttribute('data-fl-texto-disponible')
          : botón.getAttribute('data-fl-texto-agotado');
      }
    }

    grupos.forEach(function (g) {
      g.querySelectorAll('input[data-fl-opcion]').forEach(function (input) {
        input.addEventListener('change', actualizar);
      });
    });
    actualizar();
  });
}

function flInitGaleria() {
  var galerias = document.querySelectorAll('[data-fl-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-fl-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-fl-galeria-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-fl-src');
        var srcset = mini.getAttribute('data-fl-srcset');
        if (src) principal.src = src;
        if (srcset) principal.srcset = srcset;
        minis.forEach(function (m) { m.classList.remove('fl-mini-activa'); });
        mini.classList.add('fl-mini-activa');
      });
    });
  });
}

function flInitComparador() {
  var contenedores = document.querySelectorAll('[data-fl-comparador]');
  contenedores.forEach(function (cont) {
    var corte = cont.querySelector('[data-fl-comparador-corte]');
    var asa = cont.querySelector('[data-fl-comparador-asa]');
    var input = cont.querySelector('[data-fl-comparador-input]');
    if (!corte || !input || !asa) return;

    function fijarAncho() {
      var ancho = cont.getBoundingClientRect().width;
      cont.style.setProperty('--fl-corte-ancho', ancho + 'px');
    }

    function actualizar() {
      var valor = input.value;
      corte.style.width = valor + '%';
      asa.style.left = valor + '%';
    }

    fijarAncho();
    window.addEventListener('resize', fijarAncho);
    input.addEventListener('input', actualizar);
    actualizar();
  });
}

// Reemplaza la valoración/cantidad de reseñas "de ejemplo" (fija en el
// editor, ★ 4.0 de 5 · 2 reseñas) por la cifra REAL que calcula el widget
// de reseñas de Judge.me para este producto, apenas esté disponible. Así
// no hace falta editar esos textos a mano cada vez que llegan reseñas
// nuevas. Si el widget tarda en cargar o todavía no hay reseñas, se deja
// el texto de respaldo que puso el usuario en el editor.
function flSincronizarValoracion() {
  var destinos = document.querySelectorAll('[data-fl-valoracion-auto]');
  var contenedor = document.querySelector('#judgeme_product_reviews');
  if (!destinos.length || !contenedor) return;

  function aplicar(elPromedio) {
    var textos = elPromedio.querySelectorAll('.jm-text');
    if (textos.length < 2) return;
    var puntaje = textos[0].textContent.trim();
    var cantidadTexto = textos[1].textContent.trim();
    var cantidadNum = parseInt(cantidadTexto, 10);
    if (!puntaje || !cantidadNum) return;
    var texto = puntaje + ' de 5 · ' + cantidadTexto;
    destinos.forEach(function (el) { el.textContent = texto; });
  }

  var existente = contenedor.querySelector('.jm-average-rating-display');
  if (existente) { aplicar(existente); return; }

  var obs = new MutationObserver(function () {
    var el = contenedor.querySelector('.jm-average-rating-display');
    if (el) { aplicar(el); obs.disconnect(); }
  });
  obs.observe(contenedor, { childList: true, subtree: true });
  setTimeout(function () { obs.disconnect(); }, 15000);
}

document.addEventListener('DOMContentLoaded', function () {
  flInitReveal();
  flInitContadores();
  flInitAcordeon();
  flInitComparador();
  flInitVariantes();
  flInitGaleria();
  flSincronizarValoracion();
});
